exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clients-journey-board-stageId,\n.clients-journey-board-stageId-childId {\n    max-width: 100%;\n}\n", ""]);

// exports
